import { useEffect, useState } from "react";
import TableFilterPage from "./tableFilterPage";
import AddCreationPage from "./addCreation";
import { useDispatch } from "react-redux";
import {
  getClientListNetworkAction,
  getFacilityCategoryNetworkAction,
} from "../../../../redux/actions/TestPackageCreationAction";
import { initialFilterState } from "./helper";

const PackageCreation = () => {
  const dispatch = useDispatch();
  const [showCreationPage, setShowCreationPage] = useState(false);
  const [isRowData, setIsRowData] = useState(null);
  const [searchFilter, setSearchFilter] = useState(initialFilterState);

  useEffect(() => {
    dispatch(getClientListNetworkAction());
    dispatch(getFacilityCategoryNetworkAction('PACKAGE'));
  }, []);

  return showCreationPage ? (
    <AddCreationPage
      setShowCreationPage={setShowCreationPage}
      setIsRowData={setIsRowData}
      isRowData={isRowData}
    />
  ) : (
    <TableFilterPage
      setShowCreationPage={setShowCreationPage}
      setIsRowData={setIsRowData}
      searchFilter={searchFilter}
      setSearchFilter={setSearchFilter}
    />
  );
};

export default PackageCreation;
